import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import SportModal from "@/Modals/WebDataManagement/MasterData/Sports/Modal";
import { columns } from "./Columns";
import { sportsMasterDataApi } from "@/apis/apis";

export default function SportsPage() {
  return (
    <MasterDataBaseTable
      label="Sport"
      apiURL={sportsMasterDataApi}
      columns={columns()}
      ModalComponent={SportModal}
      importData={BASE_IMPORT_DATA.SPORTS}
      enableSortData={true}
    />
  );
}
